import React, { Component } from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';

import Table from '../components/table/table';
import TableRegisterButton from '../components/table/registerButton';
import ModalComponent from '../components/modal';

import AdmMenusAction from '../app/store/actions/admMenu';

import Notification from '../components/notifications';
import itemsPage from '../data/itemsPage';

import { history } from '../routers/AppRouter';
import ROUTES from '../data/routes';

class AdmMenusPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: itemsPage.page.limit,
      show: false,
      page: 1,
      search: '',
      showModal: false,
      orderBy: 'ASC',
      field: 'id',
    };
  }

  async componentDidMount() {    
    if (this.props.location.search) {
      const { search } = this.props.location;
      const splited = search.split('=');
      const level = splited[1];      
      await this.setState({ level});
      this.props.saveAdmMenuCurrentLevel(level);
    } else {
      await this.setState({ level: this.props.currentLevel || ''});      
    }
    this.searchAdmMenus();
  }

  updateValues = async (search = '', page = 1) => {
    await this.setState({ search, page });
    await this.searchAdmMenus();
  }

  searchAdmMenus = async () => {
    const {
      search, page, limit, orderBy, field = '', level,
    } = this.state;
    const skip = (page - 1) * limit;

    await this.props.getAdmMenus(limit, skip, search, orderBy, field, level);
  }

  deleteAdmMenuModal = async (admMenuId) => {
    await this.setState({ selectItemToDelete: admMenuId, showModal: true });
  }

  deleteAdmMenu = async () => {
    const { selectItemToDelete } = this.state;

    if (selectItemToDelete) {
      await this.props.deleteAdmMenu(selectItemToDelete);
      await this.setState({ selectItemToDelete: undefined, showModal: false });
      await this.searchAdmMenus();
      this.deleteNotification();
    }
  }

  deleteNotification = () => {
    this.setState({ show: true });
    setTimeout(() => { this.setState({ show: false }); }, 5000);
  }

  active = async (active, id) => {
    await this.props.updateAdmMenu({ active, id });
    await this.searchAdmMenus();
  }

  sortTable = async (field, orderBy) => {
    await this.setState({ orderBy, field });
    await this.searchAdmMenus();
  }

  render() {
    const {
      limit, show, page, showModal,
    } = this.state;
    const { admMenus = {} } = this.props;

    const tableHeader = [
      { key: 'id', value: 'ID' },
      { key: 'level', value: I18n.t('level') },
      { key: 'title', value: I18n.t('title') },
      { key: 'relevance', value: I18n.t('relevance') },
      { key: 'path', value: I18n.t('pathCode') },
      { key: 'action', value: I18n.t('action') },
    ];

    const tableData = (admMenus.rows || []).map((row, index) => ({
      key: index,
      id: row.id,
      level: row.level,
      title: row.title,
      relevance: row.relevance,
      path: row.path,  
      showMenu: row.showMenu,    
      action: (
        <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
          <div className="btn-group" role="group">
            <button
              id="btnGroupDrop1"
              type="button"
              className="btn btn-secondary dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <Translate value="action" />
            </button>
            <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
              <button
                type="button"
                className="dropdown-item dropdown-table"
                onClick={() => history.push({
                  pathname: ROUTES.ADM_MENU_FORM,
                  search: `?id=${row.id}`,
                })}
              >
                <Translate value="edit" />
              </button>
              <button
                type="button"
                className="dropdown-item dropdown-table"
                onClick={() => this.deleteAdmMenuModal(row.id)}
              >
                <Translate value="delete" />
              </button>
            </div>
          </div>
        </div>
      ),
    }));

    const tableButtons = (
      <React.Fragment>
        <TableRegisterButton route={{ pathname: ROUTES.ADM_MENU_FORM }} />
        <button
          onClick={() => this.props.getCsvAdmMenusReport()}
          type="button"
          className="btn btn-secondary margin-left-10"
        >
          <Translate value="export" />
        </button>
      </React.Fragment>
    );

    return (
      <div className="main-div-tables">

        <ModalComponent
          title={I18n.t('delete')}
          body="Deseja realmente excluir o admMenu?"
          visible={showModal}
          closeModal={() => this.setState({ showModal: false })}
          titleOkButtoon={I18n.t('confirm')}
          size={{ width: '300px', height: '170px' }}
          showButtons
          showCancel
          confirmModal={this.deleteAdmMenu}
        />

        <Table
          title={I18n.t('admMenus')}
          buttons={tableButtons}
          header={tableHeader}
          lines={tableData}
          page={page}
          perPage={limit}
          count={admMenus.count}
          searchItems={this.updateValues}
          showItemsCount
          sortTable={this.sortTable}
        />

        {show && <Notification classe="success" message={I18n.t('productDeleted')} /> }
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getAdmMenus: (limit, skip, search, order, field, level) => dispatch(
    AdmMenusAction.getAdmMenus(limit, skip, search, order, field, level),
  ),
  saveAdmMenuCurrentLevel: level => dispatch(AdmMenusAction.saveAdmMenuCurrentLevel(level)),
  updateAdmMenu: admMenu => dispatch(AdmMenusAction.updateAdmMenu(admMenu)),
  deleteAdmMenu: id => dispatch(AdmMenusAction.deleteAdmMenu(id)),
  getCsvAdmMenusReport: () => dispatch(AdmMenusAction.getCsvAdmMenusReport()),
});

const mapStateToProps = state => ({
  admMenus: state.admMenus && state.admMenus.admMenus,
  currentLevel: state.admMenus && state.admMenus.currentLevel,
});

export default connect(mapStateToProps, mapDispatchToProps)(AdmMenusPage);
